import Vue from "vue";
import Vuex from "vuex";

import {importModules} from "@/utils";
// eslint-disable-next-line
const context = require.context("./modules", true, /\.js$/);

function setModuleDefaults (module) {
    // modules default to namespaced = true, but this can be overwritten.
    return Object.assign({
        namespaced: true
    }, module);
}

const modules = importModules(context, (key, item) => {
    // extract the module subdirectory name
    const name = key.replace(/^.*(\\|\/|\:)|\..*$/g, "");
    // assign module store defaults
    return {
        [name]: setModuleDefaults(item.default)
    };
});

Vue.use(Vuex);

export default new Vuex.Store({
    // throw an error if an attempt is made to mutate the store directly
    // https://vuex.vuejs.org/en/strict.html#development-vs-production
    strict: process.env.NODE_ENV !== "production",
    // compose API modules
    modules
});



// WEBPACK FOOTER //
// ./src/store/index.js